import { Flex } from '@mantine/core';
import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { setSelectedPortfolios } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { Text } from '../../../../ui-library/typography/typography';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { ResetSelectionButton } from '../../components/reset-selection-button/reset-selection-button';
import { useCSVExportHandler } from '../../hooks/use-csv-export';
import { ComparisonMode, ViewMode } from '../../process-analysis.type';
import { PortfolioComparisonSelector } from './portfolio-comparison-selector';

export const MainSectionHeader = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const { t } = useTranslation();

  const currentPortfolio = useGlobalStore((state) => state.portfolio);
  const selectedPortfolios = useProcessAnalysisStore((state) => state.selectedPortfolios);
  const viewMode = useProcessAnalysisStore((state) => state.viewMode);
  const comparisonMode = useComparisonMode();
  const csvExportHandler = useCSVExportHandler();

  const showComparison = comparisonMode === ComparisonMode.Multiple || viewMode === ViewMode.MeasureComparison;
  const showReset = selectedPortfolios.length > 0;

  return (
    <Flex justify="space-between" align="center">
      <Flex align="center" gap={8}>
        <Text size="medium" weight="bold">
          {currentPortfolio?.name || t('common.portfolio')}
        </Text>
        {showComparison && (
          <>
            <Text size="medium">{t('process_analysis.main_section.vs')}</Text>
            <PortfolioComparisonSelector />
          </>
        )}
        {showReset && <ResetSelectionButton onClick={() => setSelectedPortfolios([])} />}
      </Flex>
      <MainSectionControls onExportCSV={csvExportHandler} chartRef={chartRef} />
    </Flex>
  );
};
